/**
* @ngdoc service
* @name giftcard.service:ItxGiftCardSvc
* @requires $q
* @requires $cacheFactory
* @requires ItxErrorMessagesFct
* @description
* Giftcard service.
*/
(function () {

    'use strict';

    angular.module('itxApp.common')
        .service('ItxGiftCardSvc', ItxGiftCardSvc);

    ItxGiftCardSvc.$inject = [
        '$q',
        '$cacheFactory',
        'ItxErrorMessagesFct',
        'ngDialog',
        'CmsConfigSvc'
    ];

    function ItxGiftCardSvc(
        $q, 
        $cacheFactory, 
        ItxErrorMessagesFct, 
        ngDialog, 
        CmsConfigSvc
    ) {

        var _this = this;
        
        _this.giftCardCache = $cacheFactory('giftCardInfo');

        var service={
            getPhysicalGiftCardForm: getPhysicalGiftCardForm,
            getVirtualGiftCardForm: getVirtualGiftCardForm,
            AddVirtualGiftCard: addVirtualGiftCard,
            getPhysicalGiftCardData: getPhysicalGiftCardData,
            getVirtualGiftCardData: getVirtualGiftCardData,
            openPopupTerms: openPopupTerms,
            getGiftCardsValues: _getGiftCardsValues
        };
        
        return service;
    
        /**
         * @ngdoc method
         * @name getPhysicalGiftCardForm
         * @methodOf giftcard.service:ItxGiftCardSvc
         * @description
         * Get information about the physical gift card in this store.
         * 
         * @return {promise} information promise
         */
        function getPhysicalGiftCardForm () {
            var deferred = $q.defer();

            var cachedCard = _this.giftCardCache.get('physicalGiftCardInfo');
            
            var action = {
                action: 'giftCard:physicalGiftCard',
                params: {
                    storeId: inditex.iStoreId,
                    catalogId: inditex.iCatalogId,
                    languageId: inditex.iLangId
                }
            };

            if (cachedCard) {
                deferred.resolve(cachedCard);
            } else {
                joyr.rest.xRestExecute([action])
                    .done(function (data) {
                        var giftCard = data[0];
                        _this.giftCardCache.put('physicalGiftCardInfo', giftCard);
                        deferred.resolve(giftCard);
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.dialog(error.errorMessage);
                    });
            }
            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name getVirtualGiftCardForm
         * @methodOf giftcard.service:ItxGiftCardSvc
         * @description
         * Get information about the virtual gift card in this store
         * 
         * @returns {Product} - a product object representing the gift card with its different prices.
         */
        function getVirtualGiftCardForm() {
            var deferred = $q.defer();

            var cachedCard = _this.giftCardCache.get('virtualGiftCardInfo');
                
            var action = {
                action: 'giftCard:virtualGiftCard',
                params: {
                    storeId: inditex.iStoreId,
                    catalogId: inditex.iCatalogId,
                    languageId: inditex.iLangId
                }
            };

            if (cachedCard) {
                deferred.resolve(cachedCard);
            } else {
                joyr.rest.xRestExecute([action])
                .done(function (data) {
                    var giftCard = data[0];
                    _this.giftCardCache.put('virtualGiftCardInfo', giftCard);
                    deferred.resolve(giftCard);
                })
                .Catch(function (error) {
                    ItxErrorMessagesFct.dialog(error.errorMessage);
                });
            }
            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @name AddVirtualGiftCard
         * @methodOf giftcard.service:ItxGiftCardSvc
         * @description
         * Add virtual gift card to the shopcart
         * @param {number} sku - The ID of the SKU representing the gift card.
         * @param {number} quantity - The number of items to add to the shopping cart.
         * @param {Object} sendInfo - Information about the sender and receiver of the gift card.
         * @param {string} sendInfo.senderName - The name of the sender.
         * @param {string} sendInfo.receiverName - The name of the receiver.
         * @param {string} sendInfo.receiverPhone - The phone number of the receiver.
         * @param {string} sendInfo.receiverEmail - The e-mail address of the receiver.
         * @param {string} sendInfo.message - A personal message for the receiver.
         * @param {Date} sendInfo.sendingDate - the date and time when to send the e-mail to the receiver.
         * @return {promise} xRestAddVirtualGiftCardToShopCart promise
         */
        function addVirtualGiftCard(object){
            var deferred = $q.defer();

            if (!object.sendInfo) {
                return deferred.rejected(new Error('The parameter [sendInfo] must be passed.')); //jshint ignore:line
            }

            if (inditex.iUserJSON.identity.userId === -1002) {
                return joyr.rest.xRestGuestLogin().done(function (result) {
                    inditex.iUserJSON.identity = result.identity;
                    inditex.iUserJSON.userId = result.userId;
                    return addVirtualGiftCard(object).then(function(response){
                        return deferred.resolve(response);
                    });
                });
            }

            var date = object.sendInfo.sendingDate || new Date();

            var action = {
                action: 'giftCard:addVirtualGiftCardToShopCart',
                params: {
                    storeId: inditex.iStoreId,
                    languageId: inditex.iLangId
                },
                data: {
                    'sku': object.sku,
                    'quantity': object.quantity,
                    'senderName': object.sendInfo.senderName,
                    'receiverName': object.sendInfo.receiverName,
                    'receiverPhone': object.sendInfo.receiverPhone,
                    'receiverEmail': object.sendInfo.receiverEmail,
                    'message': object.sendInfo.message,
                    'year': date.getFullYear(),
                    'month': date.getMonth() + 1,
                    'day': date.getDate(),
                    'hour': date.getHours(),
                    'minute': date.getMinutes()
                }
            };
            // joyr.rest.xRestAddVirtualGiftCardToShopCart(object.sku, object.quantity, object.sendInfo)
            joyr.rest.xRestExecute([action])
            .done(function (response) {
                deferred.resolve(response);
            })
            .Catch(function (error) {
                ItxErrorMessagesFct.dialog(error.errorMessage);
                deferred.reject(error.errorMessage);
            });
            
            return deferred.promise;
        }

        /**
        * @ngdoc method
        * @name getPhysicalGiftCardData
        * @methodOf giftcard.service:ItxGiftCardSvc
        * @description
        * TODO
        */
        function getPhysicalGiftCardData(){
        }
        /**
        * @ngdoc method
        * @name getVirtualGiftCardData
        * @methodOf giftcard.service:ItxGiftCardSvc
        * @description
        * Returns the virtual giftcard information associated to the giftcard item in the basket.
        * @param {number} orderItemId Order id 
        */
        function getVirtualGiftCardData(){
            var deferred = $q.defer();
            
            var item =inditex.iUserJSON.shopCart.items.filter(function(item) {
                return item.productType === 'Virtual Card';
            })[0];

            var action = {
                action: 'giftCard:virtualGiftCardData',
                params: {
                    storeId: inditex.iStoreId,
                    orderItemId: item.id,
                    languageId: inditex.iLangId
                }
            };

            joyr.rest.xRestExecute([action])
            .done(function (data) {
                deferred.resolve(data[0]);
            })
            .Catch(function(error){
                deferred.reject(error);
            });
            return deferred.promise;
        }
        /**
         * @ngdoc method
         * @methodOf giftcard.service:ItxGiftCardSvc
         * @name openPopupTerms 
         * @description 
         * Popup Terms GIFT CARD
         */
        function openPopupTerms() {
            ngDialog.open({
                template: ['<div class="giftcard-page container-dialog" itx-scrollbar><div class="content content-terms">',
                                '<div class="giftcard-terms"><itx-marketing-spot name="GiftCard_CondicionesUso"></itx-marketing-spot></div>',
                           '</div></div>'].join(' '),
                className: 'ngdialog-theme-plain new-modal ma-modal-md ma-modal-macro giftcard-dialog',
                plain: true,
                showClose: true
            });
        }

        /**
         * @ngdoc method
         * @methodOf giftcard.service:ItxGiftCardSvc
         * @name getGiftCardsValues 
         * @description 
         * Retorna el estado de las tarjetas
         */
        function _getGiftCardsValues() {

            var deferred = $q.defer();

            _this.giftCards = {
                physical: false,
                virtual: false
            };

            _this.physicalGiftCardIsRequested = false;

            // Obtenemos el valor de la tarjeta física
            CmsConfigSvc.getProperty('physical_giftcard_enabled')
            .then(function(physicalGiftCardValue) {

                _this.giftCards.physical = physicalGiftCardValue;

                // Configuramos que la realización de la consulta ha sido correcta
                _this.physicalGiftCardIsRequested = true;
            })
            // Ejecutamos "finally" falle o no falle la consulta
            .finally(function() {

                // Si la consulta a la tarjeta física falla o está desactivada
                if(!_this.physicalGiftCardIsRequested || !_this.giftCards.phyisical) {

                    // Obtenemos el valor de la tarjeta virtual
                    CmsConfigSvc.getProperty('virtual_giftcard_enabled')
                    .then(function(virtualGiftCardValue) {

                        _this.giftCards.virtual = virtualGiftCardValue; 

                        deferred.resolve(_this.giftCards);
                    });
                }
                else {
                    deferred.resolve(_this.giftCards);
                }
                
            });

            return deferred.promise;
        }
    }

})(window.itxApp);